import { render, staticRenderFns } from "./question-cap.vue?vue&type=template&id=127f2f52&scoped=true&"
import script from "./question-cap.vue?vue&type=script&lang=js&"
export * from "./question-cap.vue?vue&type=script&lang=js&"
import style0 from "./question-cap.vue?vue&type=style&index=0&id=127f2f52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f2f52",
  null
  
)

export default component.exports